import { ITreatmentQuote } from 'services/patient-proposal-api/types/common';

export const emptyTreatmentQuote: Readonly<ITreatmentQuote> = {
  title: 'Treatment Quote 1',
  info: [],
};
